import Skeleton from "@material-ui/lab/Skeleton";

interface StudentInfoSkeletonProps {
    seeMore: boolean;
}

export default function StudentInfoSkeleton({ seeMore }: StudentInfoSkeletonProps) {

    return (
        <div>
            <div className="ProgressDialog-header">
                <div>
                    <Skeleton variant="text" width={300} />
                </div>
            </div>
            <div className="ProgressDialog-student-info">
                <div className="ProgressDialog-student-container">
                    <div className="ProgressDialog-name-id-container">
                        <Skeleton variant="text" width={240} height={36} />
                        <Skeleton variant="text" width={140} height={32} />
                    </div>
                </div>
                {
                    seeMore && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                            <div className="ProgressDialog-student-info-container">
                                <div className="ProgressDialog-student-info">
                                    <Skeleton variant="text" width={100} height={20} />
                                    <Skeleton variant="text" width={100} height={20} />
                                    <Skeleton variant="text" width={100} height={20} />
                                    <Skeleton variant="text" width={100} height={20} />
                                    <Skeleton variant="text" width={100} height={20} />
                                    <Skeleton variant="text" width={100} height={20} />
                                    <Skeleton variant="text" width={100} height={20} />
                                    <Skeleton variant="text" width={100} height={20} />
                                    <Skeleton variant="text" width={100} height={20} />
                                </div>
                                <div className="ProgressDialog-student-info">
                                    <Skeleton variant="text" width={180} height={20} />
                                    <Skeleton variant="text" width={180} height={20} />
                                    <Skeleton variant="text" width={180} height={20} />
                                    <Skeleton variant="text" width={180} height={20} />
                                    <Skeleton variant="text" width={180} height={20} />
                                    <Skeleton variant="text" width={180} height={20} />
                                    <Skeleton variant="text" width={180} height={20} />
                                    <Skeleton variant="text" width={180} height={20} />
                                    <Skeleton variant="text" width={180} height={20} />
                                </div>
                            </div>
                        </div>
                    )

                }
            </div>
        </div>
    )
}
